import React from "react";
import { Sprout } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function resolveSrc(src) {
  if (!src) return src;
  // Relative API path → prepend backend URL so <img> can load from cross-origin
  if (src.startsWith("/api/")) return `${BACKEND_URL}${src}`;
  return src;
}

// Renders the persona avatar image with a graceful initial-letter fallback.
export default function Avatar({ src, name, size = 48, className = "" }) {
  const [errored, setErrored] = React.useState(false);
  const initial = (name || "?").trim().charAt(0).toUpperCase();
  const px = `${size}px`;
  const resolved = resolveSrc(src);

  if (!resolved || errored) {
    return (
      <div
        className={`rounded-full bg-[#F2EFE9] text-[#2D2926] flex items-center justify-center font-serif ${className}`}
        style={{ width: px, height: px, fontSize: `${size * 0.45}px` }}
        aria-label={name}
      >
        {initial || <Sprout size={size * 0.5} strokeWidth={1.5} />}
      </div>
    );
  }
  return (
    <img
      src={resolved}
      alt={name}
      onError={() => setErrored(true)}
      className={`rounded-full object-cover bg-[#F2EFE9] ${className}`}
      style={{ width: px, height: px }}
    />
  );
}
